module.exports = __webpack_public_path__ + "assets/veteran-943d953c7a1643106d9af704200afcbe.svg";